// R-NAV-1 — Role-denial surface (spec §2.6, §global "بدون‌دسترسی").
//
// Rendered by AppShell when an authenticated user navigates to a
// workspace route their ACTIVE role may not see (route-roles.ts). The
// spec is explicit: a wrong-role visit must NOT redirect to /login (the
// user is signed in) — it shows a polite denial with a way back to their
// own role home. The api's 403 is the real gate; this is UX + defence.
//
// Uses the shared EmptyState primitive so the "no access" signature
// matches every other empty/blocked surface in the app.
import React from "react";
import { useTranslation } from "react-i18next";
import { Icon } from "../icons";
import { Button, EmptyState } from "../ui";
import { useRole } from "../role";
import { useGo } from "../router";

export interface RoleDeniedProps {
  /** The route id the user tried to reach (shown for context). */
  routeId?: string;
}

export const RoleDenied = ({ routeId }: RoleDeniedProps): React.ReactElement => {
  // S-FIX-BUNDLE-4 / R2-007 — سطحِ «بدون دسترسی» دوزبانه شد. `shell` پیش از
  // اولین پِینت حاضر است، پس این صفحه هرگز کلیدِ خام نشان نمی‌دهد.
  const { t } = useTranslation("shell");
  const go = useGo();
  const { role, activeRoleId } = useRole();
  // Land back on the active role's home; fall back to the public home if
  // somehow there's no active role (shouldn't happen past the auth gate).
  const homeRoute = activeRoleId ? role.homeRoute : "home";

  return (
    <main
      id="role-denied"
      data-screen-label={t("denied.screenLabel")}
      className="page-shell"
      style={{ minHeight: "60vh", display: "flex", alignItems: "center", justifyContent: "center" }}
    >
      <EmptyState
        icon={<Icon name="shield" size={26} />}
        title={t("denied.title")}
        body={role?.label ? t("denied.bodyWithRole", { role: role.label }) : t("denied.body")}
        cta={
          <Button variant="primary" size="md" onClick={() => go(homeRoute)}>
            {t("denied.cta")}
          </Button>
        }
      />
    </main>
  );
};

export default RoleDenied;
